(() => {
  const germanColors = {
    'Vert sauge': 'Salbeigrün', 'Beige': 'Beige', 'Noir': 'Schwarz',
    'Camel': 'Camel', 'Café': 'Kaffeebraun', 'Anthracite': 'Anthrazit',
    'Bleu ciel': 'Himmelblau', 'Gris clair': 'Hellgrau', 'Gris nuancé': 'Grau meliert',
    'Rose nuancé': 'Altrosa meliert', 'Orange': 'Orange', 'Rose poudré': 'Puderrosa',
    'Brun marbré': 'Braun marmoriert', 'Camel marbré': 'Camel marmoriert',
    'Anthracite marbré': 'Anthrazit marmoriert', 'Gris clair marbré': 'Hellgrau marmoriert',
    'Blanc': 'Weiß', 'Multicolore pastel': 'Pastell mehrfarbig'
  };
  const japaneseColors = {
    'Vert sauge': 'セージグリーン', 'Beige': 'ベージュ', 'Noir': 'ブラック',
    'Camel': 'キャメル', 'Café': 'コーヒーブラウン', 'Anthracite': 'チャコールグレー',
    'Bleu ciel': 'スカイブルー', 'Gris clair': 'ライトグレー', 'Gris nuancé': 'グレーミックス',
    'Rose nuancé': 'ローズミックス', 'Orange': 'オレンジ', 'Rose poudré': 'ダスティピンク',
    'Brun marbré': 'マーブルブラウン', 'Camel marbré': 'マーブルキャメル',
    'Anthracite marbré': 'マーブルチャコール', 'Gris clair marbré': 'マーブルライトグレー',
    'Blanc': 'ホワイト', 'Multicolore pastel': 'パステルマルチカラー'
  };
  const buttonColors = {
    'Vert sauge': { background: '#657255', text: '#fff' },
    'Beige': { background: '#d6c0a5', text: '#24201d' },
    'Noir': { background: '#222222', text: '#fff' },
    'Camel': { background: '#916441', text: '#fff' },
    'Café': { background: '#63432f', text: '#fff' },
    'Anthracite': { background: '#45464a', text: '#fff' },
    'Bleu ciel': { background: '#a9cce2', text: '#172b37' },
    'Gris clair': { background: '#c8ccce', text: '#202428' },
    'Gris nuancé': { background: '#6f6a70', text: '#fff' },
    'Rose nuancé': { background: '#91595f', text: '#fff' },
    'Orange': { background: '#b84a1e', text: '#fff' },
    'Rose poudré': { background: '#e5b9b8', text: '#332527' },
    'Brun marbré': { background: '#78553c', text: '#fff' },
    'Camel marbré': { background: '#ab8a69', text: '#231c17' },
    'Anthracite marbré': { background: '#62616a', text: '#fff' },
    'Gris clair marbré': { background: '#aeb4b8', text: '#1d252a' },
    'Blanc': { background: '#f4f1e9', text: '#24221e', border: '#bcb7aa' },
    'Multicolore pastel': { background: '#b5cbc4', text: '#20302c' }
  };

  // Preserve the existing logo paths; only its orange accent is recolored.
  const logoSvg = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 597 180\" role=\"img\" aria-labelledby=\"title desc\">\n  <title id=\"title\">PyreFit</title>\n  <desc id=\"desc\">Logo PyreFit avec symbole de flamme minimaliste et mot-symbole horizontal.</desc>\n  <g aria-hidden=\"true\">\n    <path fill=\"#FF6A1A\" d=\"M86 10C78 38 51 57 43 83C29 126 58 162 101 162C142 162 169 133 169 96C169 67 153 43 124 20C126 45 116 66 99 82C94 59 90 34 86 10Z\"/>\n    <path fill=\"#FFFFFF\" d=\"M101 69C91 82 78 94 78 111C78 128 89 140 104 140C120 140 132 128 132 111C132 97 124 85 113 74C113 89 108 100 101 108C97 97 97 84 101 69Z\"/>\n  </g>\n  <g aria-hidden=\"true\">\n    <path fill=\"#111820\" d=\"M303 228V0H66V708H370Q424 708 476.0 696.5Q528 685 569.0 657.5Q610 630 635.0 584.5Q660 539 660 470Q660 404 635.5 358.0Q611 312 570.5 283.0Q530 254 477.5 241.0Q425 228 370 228ZM303 523V409H353Q380 409 402.5 422.5Q425 436 425 468Q425 485 419.0 495.5Q413 506 402.5 512.0Q392 518 379.0 520.5Q366 523 353 523Z\" transform=\"translate(178.000 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#111820\" d=\"M205 20 -8 526H248L326 249H330L399 526H646L430 -32Q411 -81 387.0 -119.5Q363 -158 331.0 -185.0Q299 -212 255.5 -226.0Q212 -240 154 -240Q136 -240 117.0 -238.5Q98 -237 80.5 -234.5Q63 -232 48.0 -229.5Q33 -227 23 -224L52 -34Q65 -39 83.5 -42.5Q102 -46 117 -46Q155 -46 173.5 -30.5Q192 -15 201 9Z\" transform=\"translate(250.800 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#111820\" d=\"M53 526H275V466H277Q294 498 327.5 519.0Q361 540 406 540Q433 540 450 535L432 339Q421 342 407.5 343.5Q394 345 383 345Q338 345 311.0 319.0Q284 293 284 255V0H53Z\" transform=\"translate(318.448 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#111820\" d=\"M403 333Q403 361 382.5 379.0Q362 397 327 397Q289 397 268.0 376.0Q247 355 244 333ZM602 258Q602 245 601.5 231.5Q601 218 600 209H246Q247 195 255.5 184.0Q264 173 276.5 165.0Q289 157 304.5 153.0Q320 149 336 149Q368 149 389.5 160.5Q411 172 422 186L586 103Q551 46 484.5 13.0Q418 -20 330 -20Q273 -20 219.0 -2.0Q165 16 123.5 51.5Q82 87 57.0 140.0Q32 193 32 263Q32 328 55.0 380.5Q78 433 117.5 469.5Q157 506 210.5 526.0Q264 546 325 546Q387 546 438.0 524.5Q489 503 525.5 464.5Q562 426 582.0 373.0Q602 320 602 258Z\" transform=\"translate(364.480 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#FF6A1A\" d=\"M299 434H515V240H300V0H66V708H544V509H299Z\" transform=\"translate(428.232 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#FF6A1A\" d=\"M54 526H285V0H54ZM50 678Q50 702 59.5 723.5Q69 745 85.5 761.0Q102 777 124.0 786.5Q146 796 171 796Q195 796 216.0 786.5Q237 777 253.5 761.0Q270 745 279.5 723.5Q289 702 289 678Q289 653 279.5 631.5Q270 610 253.5 594.5Q237 579 216.0 570.0Q195 561 171 561Q146 561 124.0 570.0Q102 579 85.5 594.5Q69 610 59.5 631.5Q50 653 50 678Z\" transform=\"translate(489.496 137) scale(0.112000 -0.112000)\"/>\n    <path fill=\"#FF6A1A\" d=\"M282 -14Q176 -14 125.0 31.5Q74 77 74 173V361H0V526H73V644H297V526H411V361H297V221Q297 183 313.5 169.5Q330 156 359 156Q370 156 382.0 158.0Q394 160 401 162V4Q383 -4 350.5 -9.0Q318 -14 282 -14Z\" transform=\"translate(523.656 137) scale(0.112000 -0.112000)\"/>\n  </g>\n</svg>\n";
  const originalLogos = new Map();
  const updateLogo = (color) => {
    document.querySelectorAll('#header-group img.header-logo__image').forEach((img) => {
      if (!originalLogos.has(img)) {
        if (!img.getAttribute('src')?.includes('/pyrefit-logo-v3.svg')) return;
        originalLogos.set(img, { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') });
      }
      const svg = logoSvg.replaceAll('#FF6A1A', color);
      img.removeAttribute('srcset');
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
      img.dataset.plaidLogo = 'true';
    });
  };
  const restoreLogos = () => {
    originalLogos.forEach((original, img) => {
      img.setAttribute('src', original.src);
      if (original.srcset !== null) img.setAttribute('srcset', original.srcset);
      else img.removeAttribute('srcset');
      delete img.dataset.plaidLogo;
    });
    originalLogos.clear();
  };

  const initialize = (root) => {
    if (root.dataset.plaidReady === 'true') return;
    root.dataset.plaidReady = 'true';

    const variantsNode = root.querySelector('[data-plaid-variants]');
    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch {
      return;
    }

    const colors = [...root.querySelectorAll('[data-plaid-color]')];
    const sizes = [...root.querySelectorAll('[data-plaid-size]')];
    variants = variants.filter((variant) => sizes.some((size) => size.dataset.plaidSize === variant.options[1]));
    const guideDialog = root.querySelector('[data-plaid-guide-dialog]');
    const guideOpen = root.querySelector('[data-plaid-guide-open]');
    if (guideDialog && guideOpen && typeof guideDialog.showModal === 'function') {
      root.querySelector('[data-plaid-guide-fallback]').hidden = true;
      guideOpen.hidden = false;
      guideOpen.addEventListener('click', () => guideDialog.showModal());
      guideDialog.querySelector('[data-plaid-guide-close]').addEventListener('click', () => guideDialog.close());
      guideDialog.addEventListener('click', (event) => {
        if (event.target !== guideDialog) return;
        const bounds = guideDialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) guideDialog.close();
      });
      guideDialog.addEventListener('close', () => guideOpen.focus({ preventScroll: true }));
    }

    const form = root.querySelector('[data-plaid-form]');
    const mainButton = root.querySelector('[data-plaid-atc]');
    const sticky = root.querySelector('[data-plaid-sticky]');
    const stickyButton = root.querySelector('[data-plaid-sticky-atc]');
    const status = root.querySelector('[data-plaid-status]');
    const variantInput = root.querySelector('[data-plaid-variant-id]');
    const price = root.querySelector('[data-plaid-price]');
    const compare = root.querySelector('[data-plaid-compare]');
    const buttonPrice = root.querySelector('[data-plaid-atc-price]');
    const stickyPrice = root.querySelector('[data-plaid-sticky-price]');
    const stickySelection = root.querySelector('[data-plaid-sticky-selection]');
    const mainLabel = root.querySelector('[data-plaid-atc-label]');
    const stickyLabel = root.querySelector('[data-plaid-sticky-label]');
    const colorLabel = root.querySelector('[data-plaid-color-label]');
    const sizeLabel = root.querySelector('[data-plaid-size-label]');
    const isGerman = /^de(?:-|$)/i.test(root.dataset.locale || document.documentElement.lang);
    const isJapanese = /^ja(?:-|$)/i.test(root.dataset.locale || document.documentElement.lang);
    const displayColor = (color) => isJapanese ? (japaneseColors[color] || color) : isGerman ? (germanColors[color] || color) : color;
    const canonicalColor = (color) => {
      const locale = (root.dataset.locale || document.documentElement.lang).slice(0, 2);
      if (locale === 'it' || locale === 'pl') {
        const index = colors.findIndex((item) => item.dataset.plaidColor === color);
        return Object.keys(buttonColors)[index] || color;
      }
      return Object.keys(japaneseColors).find((source) => japaneseColors[source] === color) || color;
    };
    const page = root.closest('.plaid-page');
    const currencyFormatter = new Intl.NumberFormat(root.dataset.locale || undefined, {
      style: 'currency',
      currency: root.dataset.currency || 'EUR'
    });
    let selectedColor = colors.find((item) => item.getAttribute('aria-pressed') === 'true')?.dataset.plaidColor || colors[0]?.dataset.plaidColor;
    let selectedSize = sizes.find((item) => item.getAttribute('aria-pressed') === 'true')?.dataset.plaidSize || sizes[0]?.dataset.plaidSize;
    let selectedVariant = null;
    let pending = false;

    const findVariant = () => variants.find((variant) => variant.options[0] === selectedColor && variant.options[1] === selectedSize) || null;
    const formatted = (variant, field, fallback) => variant?.[field] || (variant ? currencyFormatter.format(variant[fallback] / 100) : '');

    const updateStickyVisibility = () => {
      const bottom = mainButton.getBoundingClientRect().bottom;
      const footer = document.querySelector('footer, #shopify-section-footer, [data-section-type="footer"]');
      const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight + sticky.offsetHeight;
      const modalOpen = !!document.querySelector('dialog[open], [role="dialog"][aria-modal="true"]:not([hidden])');
      const show = bottom < 0 && !footerVisible && !modalOpen;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyButton.tabIndex = show ? 0 : -1;
    };

    const colorToggle = root.querySelector('[data-plaid-color-toggle]');
    const colorList = root.querySelector('[data-plaid-color-list]');
    let colorsExpanded = false;
    const updateColorChoices = () => {
      if (!colorToggle || !colorList) return;
      for (const [index, item] of colors.entries()) {
        item.hidden = !colorsExpanded && index >= 6 && item.dataset.plaidColor !== selectedColor;
      }
      colorToggle.hidden = false;
      colorToggle.setAttribute('aria-expanded', String(colorsExpanded));
      colorToggle.textContent = colorsExpanded ? colorToggle.dataset.lessLabel : colorToggle.dataset.moreLabel;
    };
    colorToggle?.addEventListener('click', () => {
      colorsExpanded = !colorsExpanded;
      updateColorChoices();
    });

    const render = ({ updateUrl = false, announce = true } = {}) => {
      selectedVariant = findVariant();
      const buttonColor = buttonColors[canonicalColor(selectedColor)] || { background: '#171717', text: '#fff' };
      root.style.setProperty('--plaid-atc-bg', buttonColor.background);
      root.style.setProperty('--plaid-atc-text', buttonColor.text);
      root.style.setProperty('--plaid-atc-border', buttonColor.border || buttonColor.background);
      // These variables are consumed only by the dedicated Plaid page/header rules.
      if (page) {
        document.body.classList.add('plaid-color-page');
        const rgb = buttonColor.background.slice(1).match(/../g).map((part) => parseInt(part, 16));
        const ink = buttonColor.text === '#fff' ? buttonColor.background : `rgb(${rgb.map((value) => Math.round(value * 0.45)).join(' ')})`;
        document.body.style.setProperty('--plaid-page-accent', buttonColor.background);
        document.body.style.setProperty('--plaid-page-on-accent', buttonColor.text);
        document.body.style.setProperty('--plaid-page-accent-ink', ink);
        document.body.style.setProperty('--plaid-page-accent-rgb', rgb.join(' '));
        updateLogo(ink);
      }
      const label = pending ? root.dataset.loadingLabel : selectedVariant ? (selectedVariant.available ? root.dataset.addLabel : root.dataset.soldLabel) : root.dataset.unavailableLabel;
      const validPrice = selectedVariant ? formatted(selectedVariant, 'priceFormatted', 'price') : '';
      const isDisabled = pending || !selectedVariant?.available;

      colors.forEach((item) => {
        const isSelected = item.dataset.plaidColor === selectedColor;
        const candidate = variants.find((variant) => variant.options[0] === item.dataset.plaidColor && variant.options[1] === selectedSize);
        item.setAttribute('aria-pressed', String(isSelected));
        item.setAttribute('aria-label', `${displayColor(item.dataset.plaidColor)}${candidate ? (candidate.available ? '' : ` — ${root.dataset.soldLabel}`) : ` — ${root.dataset.missingLabel}`}`);
        item.title = displayColor(item.dataset.plaidColor);
        item.classList.toggle('is-selected', isSelected);
        item.classList.toggle('is-unavailable', !candidate || !candidate.available);
      });
      sizes.forEach((item) => {
        const isSelected = item.dataset.plaidSize === selectedSize;
        const candidate = variants.find((variant) => variant.options[0] === selectedColor && variant.options[1] === item.dataset.plaidSize);
        item.setAttribute('aria-pressed', String(isSelected));
        item.setAttribute('aria-label', `${item.dataset.plaidSize}${candidate ? (candidate.available ? '' : ` — ${root.dataset.soldLabel}`) : ` — ${root.dataset.missingLabel}`}`);
        item.classList.toggle('is-selected', isSelected);
        item.classList.toggle('is-unavailable', !candidate || !candidate.available);
      });
      colorLabel.textContent = displayColor(selectedColor) || '';
      sizeLabel.textContent = selectedSize || '';
      stickySelection.textContent = [displayColor(selectedColor), selectedSize].filter(Boolean).join(' · ');
      price.textContent = validPrice;
      buttonPrice.textContent = validPrice;
      stickyPrice.textContent = validPrice;
      const hasCompare = selectedVariant?.compareAtPrice > selectedVariant?.price;
      compare.hidden = !hasCompare;
      compare.textContent = hasCompare ? formatted(selectedVariant, 'compareFormatted', 'compareAtPrice') : '';
      mainLabel.textContent = label;
      stickyLabel.textContent = label;
      mainButton.disabled = isDisabled;
      stickyButton.disabled = isDisabled;
      variantInput.value = selectedVariant?.id || '';
      updateColorChoices();
      for (const final of document.querySelectorAll('[data-plaid-final]')) {
        const finalButton = final.querySelector('[data-plaid-final-atc]');
        final.querySelector('[data-plaid-final-selection]').textContent = [displayColor(selectedColor), selectedSize].filter(Boolean).join(' · ');
        final.querySelector('[data-plaid-final-price]').textContent = validPrice;
        const finalChoice = final.querySelector('[data-plaid-final-choice]');
        finalChoice.setAttribute('href', `#${root.id}`);
        finalChoice.onclick = (event) => {
          event.preventDefault();
          colors.find((item) => item.getAttribute('aria-pressed') === 'true')?.focus({ preventScroll: true });
          root.scrollIntoView({ behavior: 'instant', block: 'start' });
        };
        finalButton.setAttribute('form', form.getAttribute('id'));
        finalButton.hidden = false;
        finalButton.disabled = isDisabled;
        finalButton.textContent = label;
      }
      status.textContent = selectedVariant ? '' : root.dataset.missingLabel;

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (selectedVariant) url.searchParams.set('variant', selectedVariant.id);
        else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
      if (announce) {
        root.dispatchEvent(new CustomEvent('plaid:variant-change', {
          bubbles: true,
          detail: { variantId: selectedVariant?.id || null, color: selectedColor, size: selectedSize, variant: selectedVariant }
        }));
      }
      updateStickyVisibility();
    };

    colors.forEach((item) => item.addEventListener('click', () => {
      selectedColor = item.dataset.plaidColor;
      render({ updateUrl: true });
    }));
    sizes.forEach((item) => item.addEventListener('click', () => {
      selectedSize = item.dataset.plaidSize;
      render({ updateUrl: true });
    }));

    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      const variant = variants.find((item) => String(item.id) === id);
      if (!variant) return;
      selectedColor = variant.options[0];
      selectedSize = variant.options[1];
      render();
    });

    const addToCart = async (event) => {
      event.preventDefault();
      if (pending || !selectedVariant?.available) return;
      pending = true;
      status.textContent = '';
      render({ announce: false });
      try {
        const { CartAddEvent } = await import('@theme/events');
        await customElements.whenDefined('cart-drawer-component');
        const sections = [...new Set([...document.querySelectorAll('cart-items-component')]
          .map((item) => item.dataset.sectionId).filter(Boolean))];
        const variantId = String(selectedVariant.id);
        const url = new URL(root.dataset.cartAddUrl, window.location.origin);
        url.pathname = `${url.pathname.replace(/\/$/, '')}.js`;
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections,
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) throw new Error(`Cart response ${response.status}`);
        const added = await response.json();
        const cartResponse = await fetch(`${root.dataset.cartUrl.replace(/\/$/, '')}.js`, {
          credentials: 'same-origin', headers: { Accept: 'application/json' }
        });
        const cart = cartResponse.ok ? await cartResponse.json() : undefined;
        root.dispatchEvent(new CartAddEvent(cart, variantId, {
          source: 'product-form-component', itemCount: 1, variantId,
          sections: added.sections
        }));
        document.querySelector('cart-drawer-component')?.open();
      } catch {
        status.textContent = root.dataset.errorLabel;
      } finally {
        pending = false;
        render({ announce: false });
      }
    };
    form.addEventListener('submit', addToCart);
    stickyButton.addEventListener('click', () => form.requestSubmit(mainButton));
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    document.addEventListener('transitionend', updateStickyVisibility);
    render({ announce: false });
  };

  const mount = () => {
    if (!document.querySelector('.plaid-page [data-plaid-buybox]')) {
      document.body.classList.remove('plaid-color-page');
      restoreLogos();
      ['accent', 'on-accent', 'accent-ink', 'accent-rgb'].forEach((name) => document.body.style.removeProperty(`--plaid-page-${name}`));
    }
    document.querySelectorAll('[data-plaid-buybox]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(mount));
})();
